/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <path
    stroke="currentColor"
    d="M10.1878.8576v.0002l.0106-.0044A4.7345 4.7345 0 0 1 12 .5c2.5335 0 4.6041 1.9838 4.7426 4.4824l.0074.2743V9.5h2.75c1.3807 0 2.5 1.1193 2.5 2.5v9c0 1.3807-1.1193 2.5-2.5 2.5h-15C3.1193 23.5 2 22.3807 2 21v-9c0-1.3807 1.1193-2.5 2.5-2.5h11.75V5.25C16.25 2.9028 14.3472 1 12 1a4.2404 4.2404 0 0 0-1.5575.2946c-.1795.027-.2515-.0112-.2722-.0239-.03-.0184-.0565-.0503-.0791-.099-.0009-.004-.0044-.0198-.0057-.0482a.4744.4744 0 0 1 .0138-.1366c.0237-.0922.0597-.1182.0885-.1293ZM4.5 10c-1.1046 0-2 .8954-2 2v9c0 1.1046.8954 2 2 2h15c1.1046 0 2-.8954 2-2v-9c0-1.1046-.8954-2-2-2h-15Zm8.5 6.5c0 .5523-.4477 1-1 1s-1-.4477-1-1 .4477-1 1-1 1 .4477 1 1Z"
  />,
  'Unlock'
);
